import { FunctionComponent } from 'react';
import './contact.scss';
import Footer from '../shared/footer/footer';
import TopMenu from '../shared/top-menu/top-menu';
import CommunicationElement from './communication-element';
import { Email, Language, Phone, Place } from '@mui/icons-material';
import H1 from '../shared/html-tags/h1';
import DIV from '../shared/html-tags/div';
import H2 from '../shared/html-tags/h2';

export type Props = {};

const ContactSuccess: FunctionComponent<Props> = (props) => {
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  return (
    <div className="page contact">
      <TopMenu selected="contact"></TopMenu>
      <div className="page-content bg-top1 top-banner">
        <div className="inner-content">
          <div className="top-left" style={{ height: 'unset' }}>
            <div className="top-left-2" style={{ marginLeft: '0' }}>
              <H1 language="de">
                Persönlicher Support
                <br />
                für deinen Erfolg.
              </H1>
            </div>
          </div>
          <DIV language="de" className="top-right" style={{ display: 'flex' }}>
            <img
              src="/img/contact/contact-524x500.png"
              alt="Roboter telefoniert mit einem PS IMAGO PRO / SPSS User"
              style={{ border: 'none', marginTop: '0', maxHeight: '250px', borderRadius: '0' }}
            />
          </DIV>
        </div>
        <div className="inner-content">
          <div className="contact-form">
            <div className="left">
              <H2 language="de">Kontakt</H2>
              <div className="slogan">Wir entfesseln das volle Potenzial deiner Datenanalyse</div>
              <div className="contact-details">
                <CommunicationElement
                  icon={() => <Email />}
                  label={() => (
                    <>
                      <b>Email:</b>
                      <span>hello@2x4.de</span>
                    </>
                  )}
                  link="mailto://hello@2x4.de?subject=Kontaktanfrage"
                />
                <CommunicationElement
                  icon={() => <Language />}
                  label={() => (
                    <>
                      <b>Website:</b>
                      <span>predictivesolutions.2x4.de</span>
                    </>
                  )}
                  link={undefined}
                />

                <CommunicationElement
                  icon={() => <Phone />}
                  label={() => (
                    <>
                      <b>Telefon:</b>
                      <span>+49 8631 607164</span>
                    </>
                  )}
                  link={undefined}
                />

                <CommunicationElement
                  icon={() => <Place />}
                  label={() => (
                    <>
                      <b>Adresse:</b>
                      <span>Fichtenring 8, 84562 Mettenheim, Deutschland</span>
                    </>
                  )}
                  link={undefined}
                />
              </div>
            </div>
            <div className="right">
              <div className="confirmation">
                <div className="confirmation-text">
                  <h4>Vielen Dank für deine Nachricht</h4>
                  <p>
                    Wir sind schon ganz gespannt darauf, wie wir dir helfen können.
                    <br />
                    Einer unserer Experten wird sich in Kürze bei dir melden.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer></Footer>
    </div>
  );
};

export default ContactSuccess;
